import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SectionHeader from '../components/sections/partials/SectionHeader';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import '../assets/scss/style.scss';

const DataSecurity = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {
    const childRef = useRef();
    let location = useLocation();

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
        title: 'Data Security'
    };

    return (
        <CustomStyle>
            <Header navPosition="right" className="reveal-from-bottom" />
            <main className="site-content">
                <section {...props} className={outerClasses}>
                    <div className="container-sm">
                        <div className={innerClasses} style={{ textAlign: 'left' }}>
                            <SectionHeader data={sectionHeader} className="center-content" tag="h1" />
                            <p className="m-0 text-sm">
                                We protect your data as if it's our own. Luckynote holds notes, files, and links you save every day, so here's a plain-language look at how we keep it safe.
                            </p>

                            <h4 className="mt-32 mb-8">While it's on its way</h4>
                            <p className="m-0 text-sm">
                                Everything you send to and from Luckynote travels over a secure, encrypted connection, the same kind banks and other trusted apps use.
                            </p>

                            <h4 className="mt-32 mb-8">Your password</h4>
                            <p className="m-0 text-sm">
                                Your password is never stored in a way that anyone, including us, could read it back. We can help you reset it, but we can never look it up.
                            </p>

                            <h4 className="mt-32 mb-8">Your notes, files, and account data</h4>
                            <p className="m-0 text-sm">
                                Everything you save is stored securely and encrypted, both while it's saved and while it's being transferred, using trusted infrastructure partners. If you connect a third-party account or add your own API key, those are kept encrypted separately from the rest of your data.
                            </p>

                            <h4 className="mt-32 mb-8">What we don't do</h4>
                            <p className="m-0 text-sm">
                                We don't currently offer full end-to-end encryption, where even we couldn't see your notes, since that would break things like search and syncing across your devices. If that's something you specifically need, <a href="/contact" style={{ color: '#2b88d9' }}>let us know</a>. We're always listening for what matters to our users.
                            </p>

                            <h4 className="mt-32 mb-8">Your data is yours</h4>
                            <p className="m-0 text-sm">
                                You can export your entire account at any time from Settings: your folders, notes, highlights, and saved links, packaged up and sent to your email as a download. There's no lock-in and no waiting on us. If you ever want to leave, you can take everything with you.
                            </p>

                            <p className="m-0 text-sm mt-32">
                                For how we collect and use data more broadly, see our <a href="/privacy" style={{ color: '#2b88d9' }}>Privacy Policy</a>. Questions about security are always welcome at <b>support@luckynote.io</b>.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </CustomStyle>
    );
};

const CustomStyle = styled.div`
    body {
        font-size: 1rem;
    }
`;

export default DataSecurity;
